<div class="d-flex flex-row gap-2">
    <div class="text-nowrap">
        {{ yearOfBirth() || '-' }}
    </div>
    |
    <div class="text-nowrap">
        {{ deviceId() || '-' | slice:-5 }}
    </div>
    |
    <div class="text-nowrap">
        {{ type()?.toLowerCase() || '-' }}
      @if (currentPregnancy() != undefined && currentPregnancy().chance == 100) {
        <i class="m-auto fa-solid fa-circle-plus color-pink"></i>
      }
      @if (currentPregnancy() != undefined && (currentPregnancy().chance || 0) >= 50 && ((currentPregnancy().chance || 0) >= 50 && (currentPregnancy().chance || 0) < 100)) {
        <i class="m-auto fa-solid fa-circle-plus color-warning"></i>
      }
    </div>
    @if (showBatteryData()) {
        |
        <div class="text-nowrap">
            <span class="{{ batterLevelColor() }} text-truncate"><i class="{{ batteryIcon() }}"></i></span>
            @if (showBatteryLevel() && batteryVoltage() !== undefined) {
                <span class="{{ batterLevelColor() }} text-truncate"> {{ batteryVoltage() | number: '1.0-2' }}V</span>
            }
        </div>
    }
    @if (rssi()) {
        |
        <div class="text-nowrap">
            {{ rssi() }}
        </div>
    }
</div>
